// NOTE: this file was auto-generated with `libraries/icons/src/_private/transform.ts`
// Any manual edits will be overwritten via `rush build`

import { SVGProps } from 'react';

const HomeFilled = (props: SVGProps<SVGSVGElement>) => (
	<svg xmlns="http://www.w3.org/2000/svg" width="1em" height="1em" viewBox="0 0 96 96" {...props}>
		<path
			d="M62.271 87.5c-3.06 0-5.551-2.31-5.551-5.151V65.113c0-.625-.712-1.152-1.554-1.152h-14.33c-.842 0-1.554.527-1.554 1.152v17.236c0 2.84-2.49 5.152-5.552 5.152H21.17c-3.061 0-5.553-2.311-5.553-5.152V47.895c0-.624-.71-1.152-1.553-1.152-2.432 0-4.5-1.384-5.27-3.525-.714-1.986-.11-4.085 1.576-5.477L44.167 9.83c2.147-1.774 5.512-1.773 7.658 0l33.804 27.91c1.685 1.393 2.29 3.492 1.576 5.478-.77 2.14-2.838 3.525-5.27 3.525-.845 0-1.557.528-1.557 1.152v34.454c0 2.84-2.49 5.152-5.553 5.152H62.27Z"
			fillRule="evenodd"
		/>
	</svg>
);
export default HomeFilled;
